import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type AssignableQueryVariables = GraphQLTypes.Exact<{
  networkId: GraphQLTypes.Scalars['String']['input'];
  searchContains?: GraphQLTypes.InputMaybe<GraphQLTypes.LocationSearchInput>;
}>;

export type AssignableQueryResult = { __typename?: 'Query' } & {
  network?: GraphQLTypes.Maybe<
    { __typename?: 'Network' } & {
      locations?: GraphQLTypes.Maybe<
        { __typename?: 'LocationAssignableConnection' } & {
          nodes?: GraphQLTypes.Maybe<
            Array<
              GraphQLTypes.Maybe<
                | ({ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'timeZone'>)
                | ({ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'timeZone'>)
                | ({ __typename?: 'NetworksLegacyOrgLoc' } & Pick<GraphQLTypes.NetworksLegacyOrgLoc, 'timeZone'>)
                | ({ __typename?: 'NetworksOrgLoc' } & Pick<GraphQLTypes.NetworksOrgLoc, 'id' | 'timeZone'> & {
                      typename: 'NetworksOrgLoc';
                    } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>
                      >;
                      organisation?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksOrgLocOrganisation' } & Pick<GraphQLTypes.NetworksOrgLocOrganisation, 'id'>
                      >;
                    })
                | ({ __typename?: 'NetworksTerminal' } & Pick<
                    GraphQLTypes.NetworksTerminal,
                    'id' | 'name' | 'unlocode' | 'timeZone'
                  > & { typename: 'NetworksTerminal' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>
                      >;
                    })
              >
            >
          >;
        }
      >;
    }
  >;
};

export const AssignableQueryDocument = gql`
  query assignableQuery($networkId: String!, $searchContains: LocationSearchInput) {
    network(id: $networkId) {
      locations(searchContains: $searchContains) {
        nodes {
          timeZone
          ... on NetworksTerminal {
            id
            label {
              long
            }
            name
            typename: __typename
            unlocode
          }
          ... on NetworksOrgLoc {
            id
            label {
              long
            }
            organisation {
              id
            }
            typename: __typename
          }
        }
      }
    }
  }
`;
